import { useState, useEffect } from 'react';
import { CurrencyConfig, defaultCurrency, getCurrencyForCountry } from '@/lib/currency';

const CACHE_KEY = 'operota_currency';

export function useCurrency() {
  const [currency, setCurrency] = useState<CurrencyConfig>(() => {
    const cached = sessionStorage.getItem(CACHE_KEY);
    return cached ? JSON.parse(cached) : defaultCurrency;
  });

  useEffect(() => {
    if (sessionStorage.getItem(CACHE_KEY)) return;

    const doFetch = () => {
      fetch('https://ipapi.co/json/')
        .then(res => res.json())
        .then(data => {
          if (data?.country_code) {
            const result = getCurrencyForCountry(data.country_code);
            setCurrency(result);
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
          }
        })
        .catch(() => {
          // fallback to default (GBP)
        });
    };

    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(doFetch);
    } else {
      setTimeout(doFetch, 2000);
    }
  }, []);

  return currency;
}
